export default "__VITE_ASSET__BMBS4Jas__"